export interface GradientTheme {
  id: string;
  name: string;
  nameZhTW: string;
  startColor: string;
  endColor: string;
  angle: number;
  preview?: string;
}

export const gradientThemes: GradientTheme[] = [
  {
    id: 'eco-green',
    name: 'Eco Green',
    nameZhTW: '生態綠',
    startColor: '#00C853',
    endColor: '#1DE9B6',
    angle: 135,
  },
  {
    id: 'forest-energy',
    name: 'Forest Energy',
    nameZhTW: '森林能源',
    startColor: '#2E7D32',
    endColor: '#66BB6A',
    angle: 120,
  },
  {
    id: 'electric-blue',
    name: 'Electric Blue',
    nameZhTW: '電力藍',
    startColor: '#0091EA',
    endColor: '#00E5FF',
    angle: 90,
  },
  {
    id: 'ocean-tech',
    name: 'Ocean Tech',
    nameZhTW: '海洋科技',
    startColor: '#006064',
    endColor: '#00ACC1',
    angle: 135,
  },
  {
    id: 'solar-power',
    name: 'Solar Power',
    nameZhTW: '太陽能',
    startColor: '#FF6F00',
    endColor: '#FFD740',
    angle: 45,
  },
  {
    id: 'sunset-charge',
    name: 'Sunset Charge',
    nameZhTW: '夕陽充電',
    startColor: '#FF5722',
    endColor: '#FF9800',
    angle: 90,
  },
  {
    id: 'premium-purple',
    name: 'Premium Purple',
    nameZhTW: '尊貴紫',
    startColor: '#6A1B9A',
    endColor: '#AB47BC',
    angle: 135,
  },
  {
    id: 'midnight-charge',
    name: 'Midnight Charge',
    nameZhTW: '午夜充電',
    startColor: '#1A237E',
    endColor: '#3949AB',
    angle: 180,
  },
  {
    id: 'silver-tech',
    name: 'Silver Tech',
    nameZhTW: '銀色科技',
    startColor: '#455A64',
    endColor: '#90A4AE',
    angle: 135,
  },
  {
    id: 'carbon-neutral',
    name: 'Carbon Neutral',
    nameZhTW: '碳中和',
    startColor: '#263238',
    endColor: '#546E7A',
    angle: 90,
  },
  {
    id: 'fresh-mint',
    name: 'Fresh Mint',
    nameZhTW: '清新薄荷',
    startColor: '#00BFA5',
    endColor: '#64FFDA',
    angle: 120,
  },
  {
    id: 'power-grid',
    name: 'Power Grid',
    nameZhTW: '電網',
    startColor: '#F57C00',
    endColor: '#FFCC80',
    angle: 60,
  },
];